<section class="privacy py-10 text-secondary dark:text-[#F2F2F2] text-sm leading-relaxed">
  <div class="relative z-10 h-[280px] mt-[-8.25rem] bg-[#EFF5FD] dark:bg-primary-dark">
    <div class="absolute inset-0 z-20 flex flex-col gap-4 items-center justify-center mt-10">
      <div class="mt-20 flex flex-col items-center gap-4">
        <app-back />
        <h4 class="text-secondary dark:text-white text-2xl md:text-4xl font-bold">
          {{ "Privacy.Page_Title" | translate }}
        </h4>

        <h3 class="text-muted dark:text-grey-dark text-xs lg:text-base w-80 md:w-full">
          <span>{{ "Privacy.Page_Subtitle" | translate }}</span>
          <a routerLink="/contact-us" class="text-brand font-medium">
            {{ "Home_Page.Footer.Contact" | translate }}
          </a>
          {{ "Terms_Conditions.Page_Subtitle_2" | translate }}
        </h3>
      </div>
    </div>
  </div>

  <div class="mt-6 container max-w-full mx-auto px-4 cw:px-[max(32px,calc((100%_-_1328px)/2))]">
    <p class="mb-6 text-[18px]">{{ "Privacy.Intro" | translate }}</p>

    <ol class="list-decimal pl-5 text-base space-y-6 mt-2 text-[18px]" [ngClass]="{ 'pr-5': isRTL }">
      <li>
        <h2 class="font-bold text-xl mb-2">
          {{ "Privacy.Section_One_Title" | translate }}
        </h2>
        <p class="mb-1">{{ "Privacy.Privacy_Collect_Info" | translate }}</p>
        <ul class="list-disc pl-5 space-y-1" [ngClass]="{ 'pr-5': isRTL }">
          <li>{{ "Privacy.Section_One_Point_One" | translate }}</li>
          <li>{{ "Privacy.Section_One_Point_Two" | translate }}</li>
          <li>{{ "Privacy.Section_One_Point_Three" | translate }}</li>
          <li>{{ "Privacy.Section_One_Point_Four" | translate }}</li>
        </ul>
      </li>

      <li>
        <h2 class="font-bold text-xl mb-2">
          {{ "Privacy.Section_Two_Title" | translate }}
        </h2>
        <p class="mb-1">{{ "Privacy.Privacy_Helps_Us" | translate }}</p>
        <ul class="space-y-1">
          <li class="flex items-center gap-2">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
            </svg>
            <span>{{ "Privacy.Section_Two_Point_One" | translate }}</span>
          </li>
          <li class="flex items-center gap-2">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
            </svg>
            <span>{{ "Privacy.Section_Two_Point_Two" | translate }}</span>
          </li>
          <li class="flex items-center gap-2">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
            </svg>
            <span>{{ "Privacy.Section_Two_Point_Three" | translate }}</span>
          </li>
          <li class="flex items-center gap-2">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
            </svg>
            <span>{{ "Privacy.Section_Two_Point_Four" | translate }}</span>
          </li>
          <li class="flex items-center gap-2">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
            </svg>
            <span>{{ "Privacy.Section_Two_Point_Five" | translate }}</span>
          </li>
        </ul>
      </li>

      <li>
        <h2 class="font-bold text-xl mb-2">
          {{ "Privacy.Section_Three_Title" | translate }}
        </h2>
        <p class="mb-1">{{ "Privacy.Privacy_Share_Data" | translate }}</p>
        <ul class="list-disc pl-5 space-y-1" [ngClass]="{ 'pr-5': isRTL }">
          <li>{{ "Privacy.Section_Three_Point_One" | translate }}</li>
          <li>{{ "Privacy.Section_Three_Point_Two" | translate }}</li>
          <li>{{ "Privacy.Section_Three_Point_Three" | translate }}</li>
          <li>{{ "Privacy.Section_Three_Point_Four" | translate }}</li>
        </ul>
      </li>

      <li>
        <h2 class="font-bold text-xl mb-2">
          {{ "Privacy.Section_Four_Title" | translate }}
        </h2>
        <p class="mb-1">{{ "Privacy.Privacy_Your_Rights" | translate }}</p>
        <ul class="list-disc pl-5 space-y-1" [ngClass]="{ 'pr-5': isRTL }">
          <li>{{ "Privacy.Section_Four_Point_One" | translate }}</li>
          <li>{{ "Privacy.Section_Four_Point_Two" | translate }}</li>
          <li>
            <span>{{ "Privacy.Section_Four_Point_Three" | translate }}</span>
            <a href="mailto:support&#64;dreamnfly.com" class="text-brand font-medium">
              {{ "Terms_Conditions.Email" | translate }}
            </a>
          </li>
          <li>{{ "Privacy.Section_Four_Point_Four" | translate }}</li>
        </ul>
      </li>

      <li>
        <h2 class="font-bold text-xl mb-2">
          {{ "Privacy.Section_Five_Title" | translate }}
        </h2>
        <p class="mb-1">{{ "Privacy.Privacy_Security" | translate }}</p>
        <ul class="list-disc pl-5 space-y-1" [ngClass]="{ 'pr-5': isRTL }">
          <li>{{ "Privacy.Section_Five_Point_One" | translate }}</li>
          <li>{{ "Privacy.Section_Five_Point_Two" | translate }}</li>
          <li>{{ "Privacy.Section_Five_Point_Three" | translate }}</li>
        </ul>
      </li>

      <li>
        <h2 class="font-bold text-xl mb-2">
          {{ "Privacy.Section_Six_Title" | translate }}
        </h2>
        <p class="mb-1">{{ "Privacy.Privacy_Disclaimer" | translate }}</p>
        <ul class="list-disc pl-5 space-y-1" [ngClass]="{ 'pr-5': isRTL }">
          <li>{{ "Privacy.Section_Six_Point_One" | translate }}</li>
          <li>{{ "Privacy.Section_Six_Point_Two" | translate }}</li>
          <li>{{ "Privacy.Section_Six_Point_Three" | translate }}</li>
        </ul>
      </li>

      <li>
        <h2 class="font-bold text-xl mb-2">
          {{ "Privacy.Section_Seven_Title" | translate }}
        </h2>
        <p>{{ "Privacy.Section_Seven_Description" | translate }}</p>
      </li>

      <li>
        <h2 class="font-bold text-xl mb-2">
          {{ "Privacy.Section_Eight_Title" | translate }}
        </h2>
        <p>{{ "Privacy.Privacy_Cookies_Use" | translate }}</p>
        <ul class="list-disc pl-5 space-y-1" [ngClass]="{ 'pr-5': isRTL }">
          <li>{{ "Privacy.Section_Eight_Point_One" | translate }}</li>
          <li>{{ "Privacy.Section_Eight_Point_Two" | translate }}</li>
        </ul>
      </li>

      <li>
        <h2 class="font-bold text-xl mb-2">
          {{ "Privacy.Section_Nine_Title" | translate }}
        </h2>
        <p>{{ "Privacy.Section_Nine_Description" | translate }}</p>
      </li>
    </ol>

    <h4 class="p-2 mt-6 text-lg">
      {{ "Terms_Conditions.Agreement_Notice" | translate }}
      <a href="mailto:support&#64;dreamnfly.com" class="text-brand font-medium">
        {{ "Terms_Conditions.Email" | translate }}
      </a>
    </h4>
  </div>
</section>